import React from "react";
import ReactDOM from "react-dom";
import "antd/dist/antd.css";
import "./index.css";
import App from "./App";
import Dashboard from "./components/Dashboard";
import { Provider } from "react-redux";
import store from "./store";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import UnAuthorizedUser from "./components/ValidationPages/unAuthorizedUser";
import InvalidDocument from "./components/ValidationPages/invalidDocumnet";
import ResultComponent from "./components/ResultComponent/ResultComponent";
import { slideAction } from "./store/slideSlice";
import { decodeWorkWiseToken } from "./utils/helper";


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <Switch>
          {/* <Route path="/unauthorized">
            <UnAuthorizedUser/>
          </Route> */}
          <Route path="/invalid-document" >
            <ResultComponent title="Document Verification Failed , Invalid Document. " />
          </Route>
          <Route
            path="/unauthorized">
            <ResultComponent title="Security Veification Failed , Unauthorized Access." subTitle="If you believe you should have access to this document please logout and login again. Incase the issues persists please contact the document owner." />
          </Route>
          <Route path="/no-internet">
            <ResultComponent title="No Internet, Check your internet connection." />
          </Route>
          <Route exact path="/">
            <Dashboard />
          </Route>
          <Route exact path="/template/:id">
            <App isTemplate={true} />
          </Route>
          <Route exact path="/mileslides/:id">
            <App isExternal={false} />
          </Route>
          <Route exact path="/mileslides/external/:id">
            <App isExternal={true} />
          </Route>
        </Switch>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
// Initialize user information from WorkWise token (decoded payload or empty object) 
const _decodedUserInfo = decodeWorkWiseToken() || {};
store.dispatch(slideAction.setUserInformation(_decodedUserInfo));